import React, { useEffect, useState } from 'react';
import stat from '../../utils/stat';
import { isEmptyObj } from '../../utils/util';

export default (data: any, sortFunc?: (a: string, b: string) => number, pickType?:string) => {
  const [bigIndex, setBigIndex] = useState(-1);
  //let list: any[] = [];
  const [list, setList] = useState([] as any[]);
  // 默认的方式是兼容除 我的喜欢外的其他
  const sort =
    sortFunc ||
    function(a: string, b: string) {
      return String(a) == String(window.gallery.id) ? -1 : 1;
    };

  useEffect(() => {
    if (isEmptyObj(data)) {
      return;
    }
    let newList = [] as any[];
    // console.log('data change', data);
    // 排序copy from Followee/Person
    if(data instanceof Array) {
      // @ts-ignore
      newList = [...data];
    }else {
      Object.keys(data || {})
        .sort(sort).filter((key:string)=>{
          if(typeof pickType != 'undefined') {
            if(pickType == 'current') {
              return key == String(window.gallery.id);
            }
            if(pickType == 'history') {
              return key != String(window.gallery.id);
            }
          }

          return true;
        })
        .forEach((key: string) => {
          let item = data[key];
          // .list是为了兼容我的喜欢的接口返回
          (item.images || item.list || []).forEach((img: any) => {
            if(img && img.id) {
              newList.push({
                //  原始数据最好是不要进行修改，否则透传过程中太多的细节修改与丢失
                ...img,
                id: img.id,
                hash: img.hash,
                size: img.size,
                isold: item.isold,
                link: item.link || item.title, // title是为了兼容我的喜欢
                name: item.name,
                galleryid: img.galleryid,
                show_mark: img.show_mark,
                width: img.width,
                height: img.height,
              });
            }
          });
        });
      }
    setList(newList);
  }, [data]);
  const columnsClick = ({ index, id }: { index?: number; id: number }) => {
    const realIndex = list.findIndex(one => one.id === id);
    setBigIndex(realIndex);
  };
  const loadBigPic = () => {
    //loaded字段标识当前是否已经下载过大图:"loading","loaded",undefined
    //正在加载中的 ，点击无效
    console.log('load big pic', list, bigIndex);
    if (list[bigIndex] && list[bigIndex].loadStatus === 'loading') {
      return;
    }
    innerSetIndex(list, bigIndex, { loadStatus: 'loading' });
  };
  const innerSetIndex = (list: any[], index: number, params: any) => {
    setList([
      ...list.slice(0, index),
      {
        ...list[index],
        ...params
      },
      ...list.slice(index + 1)
    ]);
  };
  const loadFinish = (index: number, size?: number) => {
    console.log(index, size);
    if (-1 === index) {
      return;
    }
    var current = list[bigIndex];
    if (size) {
      innerSetIndex(list, bigIndex, { size });
    }
    if (!current) {
      return;
    }
    //只有点击加载大图(loadBigPic)才需要修改状态
    if (current.loadStatus === 'loading') {
      innerSetIndex(list, index, { loadStatus: 'loaded' });
    }
  };

  return {
    bigIndex,
    setBigIndex,
    loadFinish,
    list,
    loadBigPic,
    columnsClick
  };
};
